import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import AppLogo from '~/components/AppLogo'
import Badge from '~/components/Badge'
import Tooltip from '~/components/Tooltip'

import './styles.scss'

const ApplicationsListCellRenderer = ({
  data,
  value,
}: ICellRendererParams<
  unknown,
  {
    app_icon_url: string
    app_key: string
    device_type: string
  }[]
>): ReactElement => {
  const limit = 3

  // @ts-expect-error data is unknown
  if (data?.is_all_apps) return <div>All apps</div>

  return value ? (
    <div className="application-list-cell-renderer">
      {value.slice(0, limit).map(({ app_icon_url, device_type }, idx) => (
        <AppLogo appLogoUrl={app_icon_url} appPlatform={device_type} key={idx} size="medium" />
      ))}
      {value.length > limit ? (
        <Tooltip
          align={{ points: ['br', 'tr'] }}
          overlay={
            <div className="application-list-cell-renderer-tooltip-content">
              {value.slice(limit).map(({ app_icon_url, device_type }, idx) => (
                <AppLogo appLogoUrl={app_icon_url} appPlatform={device_type} key={idx} size="medium" />
              ))}
            </div>
          }
          placement="top"
          trigger="hover"
        >
          <div>
            <Badge className="application-list-cell-renderer__badge" value={`+ ${value.length - limit} apps`} />
          </div>
        </Tooltip>
      ) : null}
    </div>
  ) : (
    <div />
  )
}

export default ApplicationsListCellRenderer
